export enum StateDropdown {
  GET_STATE_DROPDOWN_LIST = "GET_STATE_DROPDOWN_LIST",
  SET_STATE_DROPDOWN_LOADING = "SET_STATE_DROPDOWN_LOADING",
  SET_STATE_DROPDOWN_LIST = "SET_STATE_DROPDOWN_LIST",
}

export interface StateDropdownActionType {
  type: StateDropdown;
  payload: any;
}